 
// Clearance Menu

function iceShoes() {
  let headerTitle = document.querySelector('.product-title > h1');
  if (headerTitle.innerText === 'Aero Bowls Nirvana Ice Womens Lawn Bowls Shoe') {
    let shoeSize = document.querySelectorAll('div.available > label')
    for(let i = 0; i < shoeSize.length; i++){
      shoeSize[i].style.backgroundImage = 'none';
      shoeSize[i].style.fontSize = '13px'
    }
  } else {
    return;
  }

  


  
}

setTimeout(iceShoes, 1)

  let clearanceMenu = document.querySelectorAll('div.megamenu >ul.navbar-nav.site-nav > li.level-top.menu-dropdown > a > span');
  for(let i = 0; i< clearanceMenu.length; i++) {
    if(clearanceMenu[i].innerText === 'CLEARANCE') {
      clearanceMenu[i].classList.add('clearanceMainMenu');
    }
  }


let parentH3 = document.querySelectorAll('a.has-category')
let level1 = document.querySelectorAll('ul.level-1');
let iconPlus = document.querySelectorAll('h3>i.cs-font');

let subMenu = document.querySelectorAll('li.dropdown-submenu>h3>a>span');
let level2 = document.querySelectorAll('ul.level-2');


for(let i = 0; i< parentH3.length; i++){
  let icon = document.createElement('I');
  icon.className = 'cs-font clever-icon-down js-down'
  icon.style.float = 'right';
  parentH3[i].appendChild(icon);
}


for(let i = 0; i< subMenu.length; i++){
  let icon = document.createElement('SPAN')
  icon.className = 'cs-font clever-icon-down js-down1'
  icon.style.float = 'right';
  subMenu[i].appendChild(icon)
}


for(let i = 0; i< parentH3.length; i++){
  let downElement = document.querySelectorAll('.js-down')
  parentH3[i].addEventListener('click', function() {
  level1[i].classList.toggle('show1'); 
    downElement[i].classList.toggle('clever-icon-up')
  });
}

for(let i = 0; i< iconPlus.length; i++){
  iconPlus[i].style.display = 'none';
}


for(let i = 0; i< subMenu.length; i++){
  let downElement1 = document.querySelectorAll('.js-down1')
  subMenu[i].addEventListener('click', function() {
  level2[i].classList.toggle('show1');
    downElement1[i].classList.toggle('clever-icon-up');
    });
}


let bowlsSize = document.querySelector('.js-bowlsSize').parentElement.parentElement.parentElement.parentElement;
let bowlsGrip = document.querySelector('.js-bowlsGrip').parentElement.parentElement.parentElement.parentElement;
let pageTitle = document.querySelector('.showing');

if(pageTitle.innerText.includes('Lawn Bowls')){
  bowlsSize.style.display = 'block';
  bowlsGrip.style.display = 'block';
} else {
  bowlsSize.style.display = 'none';
  bowlsGrip.style.display = 'none';
}



function hideEmptyFilter() {
  let nexSib = document.querySelectorAll('.content');
  for(let i  = 0; i < nexSib.length; i++) {
    if(nexSib[i].innerText === '') {
      nexSib[i].parentElement.style.display = 'none';
    }
  }
}

hideEmptyFilter()

  // Remove this line to access to front page
let oneSecond = 1000;
setInterval(hideEmptyFilter, oneSecond);


// function aeroAlert() {
//   let aerAlertImage = document.querySelector('.aero-alert-img')
  
//   if (window.location.href.indexOf("aero-bowls") > -1) {
//       aerAlertImage.classList.remove('aero-alert')
//     }
// }
// aeroAlert();


